import { Component } from '@angular/core';
import { BeesFooterComponent } from '../bees-footer/bees-footer.component';
import { BeesHeaderComponent } from '../bees-header/bees-header.component';

@Component({
  selector: 'app-ship-chandling',
  standalone: true,
  imports: [BeesFooterComponent, BeesHeaderComponent],
  templateUrl: './ship-chandling.component.html',
  styleUrl: './ship-chandling.component.scss'
})
export class ShipChandlingComponent {

}
